import { ArrowLeftOutlined, InboxOutlined, SendOutlined } from '@ant-design/icons';
import { useNavigate } from '@tanstack/react-router';
import { Button, Col, Form, Row, Spin, Typography, Upload, type UploadProps } from 'antd';
import { PickDate } from '@/components/date/PickDate';
import { InputNumber } from '@/components/input/InputNumber';

const { Paragraph } = Typography;
const { Dragger } = Upload;

export type FormImportacaoDiValues = {
    DI_numero: string;
    DI_data_desembaraco: string;
};

type StepInfoBoxProps = {
    draggerProps: UploadProps;
    proccessFiles: (formValues?: FormImportacaoDiValues) => void;
    disableProcessarBtn: boolean;
    isUploading: boolean;
    tipo: 'nfe' | 'di';
};

export function StepOne({
    draggerProps,
    proccessFiles,
    disableProcessarBtn,
    isUploading,
    tipo,
}: StepInfoBoxProps) {
    const navigate = useNavigate();
    const [form] = Form.useForm<FormImportacaoDiValues>();

    const processar = async (): Promise<void> => {
        if (tipo === 'di') {
            const values = await form.validateFields();
            proccessFiles(values);
        } else {
            proccessFiles();
        }
    };

    return (
        <>
            <Row className='w-full'>
                {tipo === 'nfe' ? (
                    <>
                        <Paragraph style={{ fontSize: 16 }}>
                            Este procedimento permite que sejam importadas notas fiscais emitidas
                            por outros sistemas.
                        </Paragraph>
                        <Paragraph style={{ fontSize: 16 }}>
                            Serão alimentados os seguintes cadastros: Notas Fiscais, Vendas,
                            Clientes e Produtos.
                        </Paragraph>
                    </>
                ) : (
                    <Paragraph style={{ fontSize: 16 }}>
                        Este procedimento permite a importação do XML espelho de uma DI (Declaração
                        de importação) gerado pelo Siscomex para ser emitida pela sua empresa.
                    </Paragraph>
                )}
            </Row>

            {tipo === 'di' && (
                <Form form={form} layout='vertical'>
                    <Row gutter={8}>
                        <Col lg={10} md={10} sm={12} xl={6} xs={24}>
                            <Form.Item
                                label='Número da DI/DS/DA/DIRE/DUImp'
                                name='DI_numero'
                                rules={[{ required: true }]}
                            >
                                <InputNumber />
                            </Form.Item>
                        </Col>

                        <Col lg={6} md={8} sm={12} xs={24}>
                            <Form.Item
                                label='Data de despacho'
                                name='DI_data_desembaraco'
                                rules={[{ required: true }]}
                            >
                                <PickDate />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}

            <Row gutter={[8, 8]} justify='center'>
                <Col lg={4} md={8} sm={12} xs={24}>
                    <Button
                        className='w-full'
                        icon={<ArrowLeftOutlined />}
                        onClick={() => {
                            void navigate({ to: '/a/nota-fiscal' });
                        }}
                    >
                        Voltar
                    </Button>
                </Col>

                <Col lg={4} md={8} sm={12} xs={24}>
                    <Button
                        className='w-full'
                        disabled={disableProcessarBtn}
                        icon={<SendOutlined />}
                        onClick={processar}
                        type='primary'
                    >
                        Processar
                    </Button>
                </Col>
            </Row>

            <div className='mt-3 w-full'>
                <Dragger id='dragger-input' {...draggerProps}>
                    <Spin description='Carregando...' size='large' spinning={isUploading}>
                        <p className='ant-upload-drag-icon'>
                            <InboxOutlined />
                        </p>
                        <p className='ant-upload-text'>
                            Clique ou arraste os arquivos nesta área para fazer o upload
                        </p>
                        <p className='ant-upload-hint'>
                            Suporta envio de múltiplos arquivos no formato XML
                        </p>
                    </Spin>
                </Dragger>
            </div>
        </>
    );
}
